module.exports = __webpack_public_path__ + "static/media/typeA1.e8897e6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/hero/typeA1.png
// module id = 1213
// module chunks = 0